import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

const KEY = "atelie_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const lineKey = (p) => `${p.product_id}|${p.size || ""}|${p.color || ""}`;

  const addItem = (product, { size, color, quantity = 1 }) => {
    setItems((prev) => {
      const entry = {
        product_id: product.id, name: product.name, price: product.price,
        image: product.images?.[0], size, color, quantity,
      };
      const k = lineKey(entry);
      const found = prev.find((i) => lineKey(i) === k);
      if (found) {
        return prev.map((i) => (lineKey(i) === k ? { ...i, quantity: i.quantity + quantity } : i));
      }
      return [...prev, entry];
    });
    setDrawerOpen(true);
  };

  const updateQty = (key, quantity) => {
    setItems((prev) => prev.map((i) => (lineKey(i) === key ? { ...i, quantity: Math.max(1, quantity) } : i)));
  };

  const removeItem = (key) => setItems((prev) => prev.filter((i) => lineKey(i) !== key));
  const clearCart = () => setItems([]);

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const total = items.reduce((s, i) => s + i.price * i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, addItem, updateQty, removeItem, clearCart, count, total, lineKey, drawerOpen, setDrawerOpen }}>
      {children}
    </CartContext.Provider>
  );
}
